<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        (click)="modalCtrl.dismiss()"
        fill="clear"
      >
        <ion-icon
          size="large"
          name="close"
          aria-label="close"
          slot="icon-only"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="mable-section ion-margin-top">
    <img
      class="ion-margin-bottom width-100 ion-padding-horizontal"
      src="assets/img/mable/verified.svg"
      alt="baloons flying up"
    />

    <mable-heading heading="h2">Nice one! <span>Your account is verified</span></mable-heading>

    <div class="sub-section ion-margin-horizontal">
      <p>
        {{
          hasAgreement
            ? 'You’re now able to accept agreements and book support workers to provide you support.'
            : 'You’re now able to book support workers to provide you support.'
        }}
      </p>

      <p *ngIf="!hasAgreement">Search for workers for your support needs and accept agreements to book them.</p>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <mable-button
      category="orange-500"
      (onClick)="redirect()"
      expand="block"
    >
      {{ hasAgreement ? 'Accept agreement' : 'Search workers' }}
    </mable-button>
  </ion-toolbar>
</ion-footer>
